import { render, staticRenderFns } from "./SeminarTeacherHistoryHeader.vue?vue&type=template&id=a55555d6&scoped=true&lang=pug&"
import script from "./SeminarTeacherHistoryHeader.vue?vue&type=script&lang=ts&"
export * from "./SeminarTeacherHistoryHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SeminarTeacherHistoryHeader.vue?vue&type=style&index=0&id=a55555d6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55555d6",
  null
  
)

export default component.exports